export default "__VITE_ASSET__XAclAN7m__"